/**
 * LinkHandler
 */
export const LinkHandler = (function () {

  var init =  function () {   
      
      $(document).ready(() => {
      
        // Add the click listener to update the url
        $('a[data-toggle="tab"]').on("click", function() {
          history.replaceState(null, null, $(this).attr("href"));
        });
      
        // If there is a hash in the url show the tab
        if (window.location.hash) {
          $(`a[href="${window.location.hash}"]`).tab('show')
        } 
      
      });
  }

  return {
    init: init
  }

}());


